/*
 * Celebração das datas comemorativas com canvas-confetti (https://www.kirilv.com/canvas-confetti/).
 * A biblioteca só é baixada na primeira celebração (chunk separado) e os formatos de emoji
 * são criados uma vez e reaproveitados. Quem pediu menos movimento no aparelho não vê nada.
 */

// Tamanho dos confetes; o formato de emoji precisa ser criado com a mesma escala.
const ESCALA = 2.6;

let carregamento = null;
const formas = new Map();

function carregar() {
  if (!carregamento) {
    carregamento = import(/* webpackChunkName: "confete" */ "canvas-confetti").then(
      (modulo) => modulo.default || modulo
    );
  }
  return carregamento;
}

function formasDe(confetti, emojis) {
  return emojis.map((emoji) => {
    if (!formas.has(emoji)) {
      formas.set(emoji, confetti.shapeFromText({ text: emoji, scalar: ESCALA }));
    }
    return formas.get(emoji);
  });
}

const BASE = { disableForReducedMotion: true, zIndex: 300 };

function sortear(min, max) {
  return Math.random() * (max - min) + min;
}

/** Cai do topo, em duas ondas (Halloween, Natal, Páscoa). */
function chuva(confetti, shapes, colors) {
  const onda = {
    ...BASE,
    shapes,
    colors,
    scalar: ESCALA,
    spread: 180,
    particleCount: 30,
    origin: { y: -0.1 },
    startVelocity: -35,
    ticks: 300,
    // sem giro 3D: o emoji aparece inteiro, em vez de achatado
    flat: true,
  };
  confetti(onda);
  setTimeout(() => confetti({ ...onda, particleCount: 20 }), 700);
}

/** Estouros em pontos aleatórios por 3 segundos (Ano Novo). */
function fogos(confetti, shapes, colors) {
  const fim = Date.now() + 3000;
  const timer = setInterval(() => {
    const restante = fim - Date.now();
    if (restante <= 0) {
      clearInterval(timer);
      return;
    }
    const particleCount = Math.round(40 * (restante / 3000)) + 10;
    const estouro = {
      ...BASE,
      shapes: [...shapes, "star"],
      colors,
      scalar: ESCALA,
      particleCount,
      spread: 360,
      startVelocity: 30,
      ticks: 60,
      gravity: 0.8,
      flat: true,
    };
    confetti({ ...estouro, origin: { x: sortear(0.1, 0.3), y: sortear(0.1, 0.4) } });
    confetti({ ...estouro, origin: { x: sortear(0.7, 0.9), y: sortear(0.1, 0.4) } });
  }, 250);
}

/** Dois canhões, um de cada lado, por 2 segundos (Carnaval, Festa Junina). */
function canhoes(confetti, shapes, colors) {
  const fim = Date.now() + 2000;
  const timer = setInterval(() => {
    if (Date.now() > fim) {
      clearInterval(timer);
      return;
    }
    const tiro = {
      ...BASE,
      shapes: [...shapes, "square"],
      colors,
      scalar: ESCALA,
      particleCount: 3,
      spread: 55,
    };
    confetti({ ...tiro, angle: 60, origin: { x: 0, y: 0.7 } });
    confetti({ ...tiro, angle: 120, origin: { x: 1, y: 0.7 } });
  }, 60);
}

const ESTILOS = { chuva, fogos, canhoes };

/** Dispara a celebração da data (objeto de DATAS em datasComemorativas.js). */
export async function celebrar(data) {
  if (!data?.confete) return;
  try {
    const confetti = await carregar();
    const { emojis, cores, estilo } = data.confete;
    (ESTILOS[estilo] || chuva)(confetti, formasDe(confetti, emojis), cores);
  } catch (e) {
    // Sem a animação o sistema segue normal (ex.: navegador sem canvas).
  }
}

export default celebrar;
